import { flushSync } from 'react-dom';

/**
 * Runs `remove` synchronously, then focuses the next row's remove button, else
 * the previous row's, else the first enabled `[data-add-row]` control. Rendering and
 * focusing in the same task keeps a dialog's focus trap from taking focus while
 * the removed button is gone.
 */
export function focusAfterRemoval(
  root: HTMLElement | null,
  rowIds: readonly string[],
  removedIndex: number,
  remove: () => void
): void {
  const targetId = rowIds[removedIndex + 1] ?? rowIds[removedIndex - 1];
  flushSync(remove);
  const selector = targetId ? `[data-remove-row="${targetId}"]` : '[data-add-row]:not([disabled])';
  root?.querySelector<HTMLElement>(selector)?.focus();
}
